var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightingBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    id: "Flash-1--Streamline-Plump.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Flash 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flash-1--flash-power-connect-charge-electricity-lightning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#000000",
    d: "M31.0467 0.7313C27.2452 0.5125 20.7577 0.2866 14.3615 0.7543C12.2349 0.9098 10.3987 2.2845 9.6423 4.2726C6.417 12.7489 4.8806 20.5674 4.226 24.7096C3.8154 27.3083 5.7041 29.6252 8.3019 29.8036C10.5219 29.956 13.7823 30.1138 17.5892 30.093C17.1836 33.3882 16.7609 37.7841 16.3414 42.5128C15.9656 46.7489 21.0594 49.2955 24.0913 46.0467C31.8748 37.7066 39.0102 28.4319 42.9235 23.1462C45.0762 20.2385 43.1802 16.171 39.5044 16.0754C37.8099 16.0313 35.7315 16.006 33.2859 16.0271C34.0093 12.8721 34.6632 9.4457 35.2643 6.1376C35.7525 3.451 33.8281 0.8913 31.0467 0.7313Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingBlack);
export default __webpack_public_path__ + "static/media/lighting-black.73e0fe791c65ddbe3308d930d5fc4269.svg";
export { ForwardRef as ReactComponent };